export const USEFORMBEHAVIORS_VALIDATION_TIMEOUT = 300;
